/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from '@state/settings';
import { RootState } from '@state/store';

export const KeyboardShortcuts = () => {
  const dispatch = useDispatch();
  const { appearance } = useSelector((state: RootState) => state.settings);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      switch (event.key) {
        case 'i':
          dispatch({ type: actions.SETTINGS_CHANGE_APPEARANCE_INFO, payload: !appearance.info });
          break;
        case 'm':
          dispatch({ type: actions.SETTINGS_CHANGE_APPEARANCE_MARKET, payload: !appearance.market });
          break;
        case 'l':
          dispatch({ type: actions.SETTINGS_CHANGE_APPEARANCE_LABELS, payload: !appearance.labels });
          break;
        default:
        //
      }
    };
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [appearance]);

  return null;
};
